'use strict';

import React, { Fragment } from 'react'

import { priceFromCents, centsFromPrice, getCartAbondement, getCartTotal } from '@root/utility'

import Link  from '@Pure/Link'
import Image from '@Pure/Image'

const numeral = window.numeral;

numeral.locale('en');

export default class CartTotal extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			cart: []
		};

		this.handleCartChange      = this.handleCartChange.bind(this);
		this.changeQty             = this.changeQty.bind(this);
		this.calculateShippingFees = this.calculateShippingFees.bind(this);
	}

	componentWillMount ()
	{
		var component = this;

		app.push(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleCartChange
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.calculateShippingFees
		});

		app.push(
		{
			event: 'order_processChange',
			cb: component.calculateShippingFees
		});

		component.setState(
		{
			cart: app.state.cart
		});
	}

	componentWillUnmount ()
	{
		var component = this;

		qwest.post('/cart/update', { cart: app.state.cart })
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});

		app.delete(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleCartChange
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.calculateShippingFees
		});

		app.delete(
		{
			event: 'order_processChange',
			cb: component.calculateShippingFees
		});
	}

	calculateShippingFees ()
	{
		const component = this, props = this.props;

		let shipping_method = app.state.order_process.shipping['shipping[method]'];

		let price = 0;

		if (app.state.session.EC && shipping_method === 'home')
		{
			price = app.state.session.EC.config.shipping_home_price;
		}
		else if (app.state.session.EC && shipping_method === 'EC')
		{
			price = app.state.session.EC.config.shipping_EC_price;
		}

		if (price)
		{
			price = centsFromPrice(price);
		}

		component.setState(
		{
			shipping_price: price || 0
		});
	}

	handleCartChange ()
	{
		const component = this, props = this.props;

		component.setState({ cart: app.state.cart });
	}

	changeQty (e, ref)
	{
		let item = app.state.cart.find(item => item.cart_price.ref === ref);

		if (!item) return;

		if (e === 'less')
		{
			item.cart_qty--;
		}
		else if (e === 'more')
		{
			item.cart_qty++;
		}
		else if (e)
		{
			let qty = e.target.value;

			if (item)
			{
				item.cart_qty = qty;
			}
		}

		qwest.post('/cart/update', { cart: app.state.cart })
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});

		app.emit('cartChange');
	}

	remove ( ref)
	{
		app.state.cart = app.state.cart.filter(item => item.cart_price.ref !== ref);

		qwest.post('/cart/update', { cart: app.state.cart })
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});

		app.emit('cartChange');
	}

	render ()
	{
		const component = this, props = this.props;

		let cart_total;

		if (props.source === 'cart-page')
		{
			cart_total = getCartTotal(
			{
				no_user_abondement: true,
				no_shipping: true
			});
		}
		else
		{
			cart_total = getCartTotal();
		}

		let product_abondement = cart_total.product_abondement || 0;

		if (product_abondement > 0 && props.source !== 'cart-preview')
		{
			product_abondement =
			(
				<div className="c-cart-total__abondement">
					<div className="c-cart-total__abondement-value">
						Abondement catalogue&nbsp;:
						{ ' -' + product_abondement + ' €' }
					</div>
				</div>
			);
		}
		else
		{
			product_abondement = undefined;
		}

		let total = numeral(cart_total.total || 0);

		var output =
		(
			<div className="c-cart-total">

				{ product_abondement }

				<div className="c-cart-total__content">

					<div className="c-cart-total__price">
						Total&nbsp;: { total.format('0[.]00') }&nbsp;€
					</div>

				</div>

			</div>
		);

		return output;
	}
}